<div class="card">
  <div class="service">
    <div class="service__left service__left--no-padding">
      <service-title-block
        [isAccessible]="true"
        [healthStatus]="health().status"
        [service]="service()"
        [tags]="service().tags"
        [title]="customerDescription()"
      />
    </div>

    <div class="service__flex-table">
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.PortSpeed" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ portSpeed()! | service_speed }}</div>
        </div>
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.PatchPosition" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ patchPosition() }}</div>
        </div>
      </div>
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.InterfaceType" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ interfaceType() }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
